import { render, staticRenderFns } from "./colorPalette.vue?vue&type=template&id=2074b8f9&"
import script from "./colorPalette.vue?vue&type=script&lang=js&"
export * from "./colorPalette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports